export const globalServicesManager = {
  header: {
    title: "Services und Erlebnisse",
    description: "Eine Liste für Ihr ganzes Konto. Jeden Service einmal anlegen und ankreuzen, in welchen Inseraten er angeboten wird.",
  },

  toolbar: {
    info: "Was Sie hier anlegen, erscheint in Ihrer <strong>Buchungsmaschine</strong> und auf Ihrer <strong>Website</strong>, in den angekreuzten Inseraten.",
    newService: "Neuer Service",
  },

  loading: "Services werden geladen…",

  empty: {
    title: "Noch keine Services",
    description: "Ein Transfer, eine Führung, ein Willkommenskorb… Gäste fügen sie beim Buchen hinzu.",
    create: "Den ersten anlegen",
  },

  status: {
    active: "Aktiv",
    paused: "Pausiert",
  },

  price: {
    onRequest: "Auf Anfrage",
    free: "Kostenlos",
  },

  assign: {
    title: "In welchen Inseraten",
    listingsLabel: "Ihre Inserate",
    selectAll: "Alle auswählen",
    clearAll: "Alle abwählen",
    inAll: "In allen Inseraten",
    inSome: "In {n} von {total}",
    units: "{n} Einheiten",
    pickRooms: "Zimmer auswählen",
    hideRooms: "Zimmer ausblenden",
    roomsHint: "Nur die Zimmer ankreuzen, in denen es angeboten wird. Ohne Auswahl gilt es für alle.",
    inRooms: "In 1 Zimmer | In {count} Zimmern",
    unassigned: "Nicht zugewiesen",
    helperNone: "Ohne Auswahl wird dieser Service NIRGENDWO angeboten.",
    roomsChecked: "1 ausgewählt · löschen | {count} ausgewählt · löschen",
    andMore: "+1 weiteres | +{count} weitere",
    helper: "Ohne Auswahl wird der Service in allen Ihren Inseraten angeboten.",
  },

  actions: {
    edit: "Bearbeiten",
    delete: "Löschen",
    cancel: "Abbrechen",
    save: "Speichern",
  },

  delete: {
    title: "Service löschen",
    text: "„{name}“ wird in keinem Inserat mehr angeboten. Das lässt sich nicht rückgängig machen.",
    accept: "Ja, löschen",
  },

  saved: {
    assign: "Inserate aktualisiert",
    state: "Service aktualisiert",
    deleted: "Service gelöscht",
  },

  errors: {
    load: "Ihre Services konnten nicht geladen werden.",
    assign: "Die Inserate konnten nicht gespeichert werden.",
    state: "Der Service konnte nicht geändert werden.",
    delete: "Der Service konnte nicht gelöscht werden.",
  },
};
